import { render } from "./DefaultLayout.vue?vue&type=template&id=517f65d2&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=517f65d2&lang=scss&scoped=true"

import exportComponent from "/home/parshin/rnews-cabinet/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517f65d2"]])

export default __exports__